import { AppstoreOutlined, HomeOutlined, LoginOutlined, LogoutOutlined, ProjectOutlined, ScheduleOutlined, UserOutlined } from "@ant-design/icons";
import React from "react";
import { ROLES } from "./permissions";

export const routes = {
	home: {
		key: "home",
		slug: "home",
		to: "/home",
		title: "Inicio",
		icon: <HomeOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	profile: {
		key: "profile",
		slug: "profile",
		to: "/profile",
		title: "Perfil",
		icon: <UserOutlined />,
		showInMenu: false,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	users: {
		key: "users",
		slug: "users",
		to: "/users",
		title: "Equipo",
		icon: <UserOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},

	login: {
		key: "login",
		slug: "login",
		to: "/login",
		title: "LOGIN",
		icon: <LoginOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},

	projects: {
		key: "projects",
		slug: "projects",
		to: "/projects",
		title: "Projectos",
		icon: <ProjectOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	tasks: {
		key: "tasks",
		slug: "tasks",
		to: "/tasks",
		title: "Tareas",
		icon: <ScheduleOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role],
	},
	tablero: {
		key: "tablero",
		slug: "tablero",
		to: "/tablero",
		title: "Tablero",
		icon: <AppstoreOutlined />,
		showInMenu: true,
		showHeader: true,
		showSearch: true,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
	logout: {
		key: "logout",
		slug: "logout",
		to: "/logout",
		title: "Log out",
		icon: <LogoutOutlined />,
		showInMenu: false,
		showHeader: false,
		showSearch: false,
		action: null,
		role: [ROLES.admin.role, ROLES.user.role],
	},
};
